/* ClearNova : « Explorez l'immeuble ». Illustration isométrique + caméra interactive.
   Survol : le local s'éclaire. Clic ou toucher : la caméra zoome, l'afficheur d'étage indique où l'on est,
   et des repères A, B, C apparaissent sur les objets nettoyés. Flèches : local précédent / suivant. */
(function () {
  var ORDER = ['commerces', 'restaurants', 'cliniques', 'garderies', 'bureaux', 'airbnb'];
  var FLOORS = [{ id: 3, label: 'É3', name: 'Étage 3' }, { id: 2, label: 'É2', name: 'Étage 2' }, { id: 1, label: 'RDC', name: 'Rez-de-chaussée' }];
  var SECTORS = {
    commerces: { label: 'Commerces', floor: 1, x: 24, y: 67,
      lead: 'Une entrée impeccable dès l’ouverture.',
      spots: [
        { x: 30, y: 80, name: 'Tapis d’entrée', how: 'Extraction de la saleté et du calcium de l’hiver.' },
        { x: 31.5, y: 72.5, name: 'Présentoirs et comptoirs', how: 'Dépoussiérage et nettoyage des surfaces.' },
        { x: 23.5, y: 74, name: 'Planchers et carpettes', how: 'Aspiration et lavage, sans traces.' }
      ], service: 'Bureaux / commercial' },
    restaurants: { label: 'Restaurants', floor: 1, x: 70, y: 68,
      lead: 'Gras et taches alimentaires retirés en profondeur.',
      spots: [
        { x: 80, y: 63, name: 'Banquettes', how: 'Retrait du gras et des taches alimentaires.' },
        { x: 56, y: 71, name: 'Chaises rembourrées', how: 'Shampooing des assises et des dossiers.' },
        { x: 68, y: 74, name: 'Planchers de salle', how: 'Aspiration et lavage après le service.' }
      ], service: 'Bureaux / commercial' },
    cliniques: { label: 'Cliniques', floor: 2, x: 23, y: 47,
      lead: 'Une salle d’attente propre rassure vos patients.',
      spots: [
        { x: 17, y: 49, name: 'Chaises d’attente', how: 'Nettoyage des tissus et des accoudoirs.' },
        { x: 34, y: 52, name: 'Fauteuils et banquettes', how: 'Shampooing en profondeur, séchage rapide.' },
        { x: 42, y: 61.5, name: 'Tapis d’entrée', how: 'Extraction de la saleté incrustée.' }
      ], service: 'Bureaux / commercial' },
    garderies: { label: 'Garderies', floor: 2, x: 72, y: 47,
      lead: 'Des produits choisis par un chimiste, sécuritaires pour les enfants.',
      spots: [
        { x: 68, y: 55, name: 'Tapis de jeu', how: 'Produits sécuritaires pour les tout-petits.' },
        { x: 59.5, y: 50.5, name: 'Petites chaises', how: 'Nettoyage des assises et des dossiers.' },
        { x: 87, y: 50, name: 'Matelas de sieste', how: 'Nettoyage des housses et séchage rapide.' }
      ], service: 'Bureaux / commercial' },
    bureaux: { label: 'Bureaux', floor: 3, x: 24, y: 27,
      lead: 'Le soir ou la fin de semaine, sans déranger vos équipes.',
      spots: [
        { x: 14, y: 30.5, name: 'Sofas des aires communes', how: 'Extraction à l’eau chaude, séchage rapide.' },
        { x: 24.5, y: 28.4, name: 'Chaises de bureau', how: 'Shampooing des tissus et des accoudoirs.' },
        { x: 37, y: 34, name: 'Moquettes', how: 'Aspiration en profondeur et extraction.' }
      ], service: 'Bureaux / commercial' },
    airbnb: { label: 'Airbnb', floor: 3, x: 72, y: 27,
      lead: 'Une remise à neuf rapide entre deux séjours.',
      spots: [
        { x: 80, y: 29.5, name: 'Matelas', how: 'Aspiration des acariens et retrait des taches.' },
        { x: 62, y: 28, name: 'Sofa', how: 'Nettoyage des tissus et neutralisation des odeurs.' },
        { x: 66, y: 35, name: 'Tapis', how: 'Extraction à l’eau chaude.' }
      ], service: 'Airbnb' }
  };
  var ZOOM = 1.75, LETTERS = 'ABC';
  var INTRO = '<div class="cnb-card-h cnb-card-h-intro"><span><strong>Explorez l’immeuble</strong><small>6 types de locaux sur 3 étages</small></span></div>' +
    '<p>Touchez un numéro dans l’image ou un secteur&nbsp;: la caméra entre dans le local et vous montre ce que nous y nettoyons.</p>';

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function floorOf(n) { for (var i = 0; i < FLOORS.length; i++) if (FLOORS[i].id === n) return FLOORS[i]; }

  function init(root) {
    var stage = root.querySelector('[data-cnx]');
    var card = root.querySelector('[data-cnb-card]');
    if (!stage || !card) return;
    var frame = stage.querySelector('.cnx-frame');
    var cam = stage.querySelector('.cnx-cam');
    var tilt = stage.querySelector('.cnx-tilt');
    var spot = stage.querySelector('.cnx-spot');
    var pins = [].slice.call(stage.querySelectorAll('.cnx-pin'));
    var chips = [].slice.call(root.querySelectorAll('[data-cnb-k]'));
    var btnPrev = stage.querySelector('[data-cnx-prev]');
    var btnNext = stage.querySelector('[data-cnx-next]');
    var btnAll = stage.querySelector('[data-cnx-all]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    var cur = null, zoomed = false, auto = null, touched = false;

    /* repères A, B, C sur les objets (visibles quand on est dans le local) */
    var marks = [];
    ORDER.forEach(function (k) {
      SECTORS[k].spots.forEach(function (s, i) {
        if (s.x == null) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cnx-mark'; b.tabIndex = -1;
        b.setAttribute('data-u', k); b.setAttribute('data-i', i);
        b.style.setProperty('--x', s.x + '%'); b.style.setProperty('--y', s.y + '%');
        b.setAttribute('aria-label', LETTERS[i] + ', ' + s.name + ' : ' + s.how);
        b.innerHTML = '<span>' + LETTERS[i] + '</span><em role="tooltip"><strong>' + s.name + '</strong>' + s.how + '</em>';
        b.setAttribute('data-x', s.x);
        cam.appendChild(b); marks.push(b);
      });
    });

    /* afficheur d'étage, comme dans un ascenseur, et bandeau « Vous êtes ici » */
    var lift = document.createElement('div');
    lift.className = 'cnx-lift'; lift.setAttribute('aria-hidden', 'true');
    lift.innerHTML = FLOORS.map(function (f) { return '<span data-f="' + f.id + '">' + f.label + '</span>'; }).join('');
    var here = document.createElement('div');
    here.className = 'cnx-here'; here.setAttribute('aria-live', 'polite');
    frame.appendChild(lift); frame.appendChild(here);
    var liftItems = [].slice.call(lift.children);

    root.classList.add('cnx-ready');

    function hl(i, on) {
      marks.forEach(function (m) { if (m.getAttribute('data-u') === cur) m.classList.toggle('is-hot', on && +m.getAttribute('data-i') === i); });
      [].forEach.call(card.querySelectorAll('li[data-i]'), function (li) { li.classList.toggle('is-hot', on && +li.getAttribute('data-i') === i); });
    }

    function setCard(k) {
      if (!k) { card.innerHTML = INTRO; return; }
      var d = SECTORS[k], f = floorOf(d.floor);
      card.innerHTML = '<div class="cnb-card-h"><b>' + (ORDER.indexOf(k) + 1) + '</b><span><strong>' + d.label + '</strong><small>' + f.name + '</small></span></div>' +
        '<p>' + d.lead + '</p><ul class="cnb-spots">' + d.spots.map(function (s, i) {
          return '<li data-i="' + i + '" tabindex="0"><i>' + LETTERS[i] + '</i><span><b>' + s.name + '</b><small>' + s.how + '</small></span></li>';
        }).join('') + '</ul>' +
        '<a href="#cnh-form" class="cnb-cta" data-service="' + d.service + '">Soumission pour ' + d.label.toLowerCase() + '</a>';
      var a = card.querySelector('[data-service]');
      a.addEventListener('click', function () {
        var s = document.getElementById('cnh-service') || document.querySelector('select[name="contact[Service]"]');
        if (s) { s.value = a.getAttribute('data-service'); s.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      [].forEach.call(card.querySelectorAll('li[data-i]'), function (li) {
        var i = +li.getAttribute('data-i');
        li.addEventListener('mouseenter', function () { if (zoomed) hl(i, true); });
        li.addEventListener('mouseleave', function () { hl(i, false); });
        li.addEventListener('click', function () { if (!zoomed) show(cur, true); hl(i, true); });
        li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!zoomed) show(cur, true); hl(i, true); } });
      });
    }

    function camera(k, zoom) {
      var d = k ? SECTORS[k] : null;
      if (d) { spot.style.setProperty('--sx', d.x + '%'); spot.style.setProperty('--sy', d.y + '%'); }
      stage.classList.toggle('has-spot', !!d);
      if (d && zoom) {
        var lim = 50 / ZOOM;
        cam.style.setProperty('--z', ZOOM);
        cam.style.setProperty('--tx', (50 - clamp(d.x, lim, 100 - lim)) + '%');
        cam.style.setProperty('--ty', (50 - clamp(d.y, lim, 100 - lim)) + '%');
        var fx = clamp(d.x, lim, 100 - lim);
        // bulle du côté où il reste de la place à l'écran
        marks.forEach(function (m) { if (m.getAttribute('data-u') === k) m.classList.toggle('tip-left', 50 + (+m.getAttribute('data-x') - fx) * ZOOM > 52); });
      } else {
        cam.style.setProperty('--z', 1); cam.style.setProperty('--tx', '0%'); cam.style.setProperty('--ty', '0%');
      }
      stage.classList.toggle('is-zoomed', !!(d && zoom));
      liftItems.forEach(function (s) { s.classList.toggle('is-on', !!d && +s.getAttribute('data-f') === d.floor); });
      lift.classList.toggle('is-live', !!d);
      here.innerHTML = d ? '<small>Vous êtes ici</small>' + floorOf(d.floor).name + ', ' + d.label.toLowerCase() : '';
      here.classList.toggle('is-on', !!(d && zoom));
      marks.forEach(function (m) { m.classList.toggle('is-on', !!(d && zoom) && m.getAttribute('data-u') === k); m.classList.remove('is-hot'); m.tabIndex = (d && zoom && m.getAttribute('data-u') === k) ? 0 : -1; });
    }

    function show(k, zoom) {
      cur = k; zoomed = !!(k && zoom);
      pins.forEach(function (p) { var on = p.getAttribute('data-k') === k; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      chips.forEach(function (c) { var on = c.getAttribute('data-cnb-k') === k; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.toggleAttribute('data-active', !!k);
      camera(k, zoom);
      setCard(k);
      if (btnAll) btnAll.disabled = !zoomed;
    }
    function stop() { touched = true; if (auto) { clearInterval(auto); auto = null; } }
    function preview(k) { stop(); if (!zoomed) show(k, false); else if (k !== cur) show(k, true); }
    function open(k) { stop(); show(k, true); }
    function step(dir) {
      stop();
      var i = cur ? ORDER.indexOf(cur) : (dir > 0 ? -1 : 0);
      show(ORDER[(i + dir + ORDER.length) % ORDER.length], true);
    }

    pins.concat(chips).forEach(function (el) {
      var k = el.getAttribute('data-k') || el.getAttribute('data-cnb-k');
      el.addEventListener('mouseenter', function () { if (canHover) preview(k); });
      el.addEventListener('click', function (e) { e.preventDefault(); open(k); });
    });
    marks.forEach(function (m) {
      var i = +m.getAttribute('data-i');
      m.addEventListener('mouseenter', function () { hl(i, true); });
      m.addEventListener('mouseleave', function () { hl(i, false); });
      m.addEventListener('focus', function () { hl(i, true); });
      m.addEventListener('blur', function () { hl(i, false); });
      m.addEventListener('click', function (e) { e.preventDefault(); var on = m.classList.contains('is-hot'); hl(i, !on || !canHover); });
    });
    if (btnPrev) btnPrev.addEventListener('click', function () { step(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { step(1); });
    if (btnAll) btnAll.addEventListener('click', function () { stop(); show(null, false); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { stop(); show(null, false); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    // relief 3D : l'image s'incline légèrement en suivant la souris
    if (!reduce && tilt && canHover) {
      var raf = 0;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          tilt.style.setProperty('--ry', (px * 7).toFixed(2) + 'deg');
          tilt.style.setProperty('--rx', (-py * 5).toFixed(2) + 'deg');
        });
      });
      stage.addEventListener('mouseleave', function () { tilt.style.setProperty('--ry', '0deg'); tilt.style.setProperty('--rx', '0deg'); });
    }

    show(null, false);

    // visite guidée : les locaux s'éclairent un à un tant que le visiteur n'a rien touché
    if (!reduce && 'IntersectionObserver' in window) {
      var i = -1;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (touched) return;
          if (e.isIntersecting && !auto) auto = setInterval(function () { i = (i + 1) % ORDER.length; show(ORDER[i], false); }, 2800);
          if (!e.isIntersecting && auto) { clearInterval(auto); auto = null; }
        });
      }, { threshold: 0.35 }).observe(stage);
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-cnb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
